import React                                     from 'react';
import PropTypes                                 from 'prop-types';
import {getIconByGender, getTranslationByGender} from "./SearchResultsHelper";
import TransformingSelect                        from "../Form/TransformingSelect";
import Translations                              from "../../utils/Translations";
import { generateKey } from '../../utils/CommonUtils';


class SearchResultsFilter extends React.PureComponent {

	constructor(props) {
		super(props);

		this.state = {filter: this.props.filter};

		this.onChangeGender  = this.onChangeGender.bind(this);
		this.onChangeOnline  = this.onChangeOnline.bind(this);
		this.onChangeFree    = this.onChangeFree.bind(this);
		this.onChangeFsk18   = this.onChangeFsk18.bind(this);
		this.onChangeSorting = this.onChangeSorting.bind(this);
		this.onFilterChange  = this.onFilterChange.bind(this);

		// Sub-components
		this.getGenderFilter = this.getGenderFilter.bind(this);
		this.getOnlineFilter = this.getOnlineFilter.bind(this);
		this.getSorting      = this.getSorting.bind(this);
	}

    static getDerivedStateFromProps(nextProps) {
        return {
            filter: nextProps.filter
        };
    }

	onChangeGender(e, gender) {
		e.preventDefault();

		if (this.state.filter.gender.indexOf(gender) !== -1) {
			this.state.filter.gender.splice(this.state.filter.gender.indexOf(gender), 1);
		} else {
			this.state.filter.gender.push(gender);
		}

		this.onFilterChange();
	}

	onChangeOnline() {
		this.state.filter.online = this.state.filter.online ? null : true;

		this.onFilterChange();
	}

	onChangeFree() {
		this.state.filter.free = this.state.filter.free ? null : true;

		this.onFilterChange();
	}

	onChangeFsk18() {
		this.state.filter.fsk18 = this.state.filter.fsk18 ? null : true;

		this.onFilterChange();
	}

	onChangeSorting(newSort) {
		this.state.filter.sorting = newSort;

		this.onFilterChange();
	}

	onFilterChange() {
		this.forceUpdate();
		this.props.onFilterChange(this.state.filter);
	}

	getGenderFilterButton(gender, idx) {
		const active = this.state.filter.gender.indexOf(gender) > -1;

		const activeIcon        = active ? '-icon-close-full' : '-icon-plus-full';
		const genderIcon        = getIconByGender(gender);
		const genderTranslation = getTranslationByGender(gender);

		return (
			<button key={generateKey(genderIcon, idx)} onClick={e => (this.onChangeGender(e, gender))} className={"searchresults_filter-gender-button" + (active ? ' -is-active' : '')}>
				<span className={"icon " + genderIcon} /> <span>{genderTranslation}</span> <span className={"icon " + activeIcon} />
			</button>
		);
	}

	getGenderFilter(idx) {
		const genders = [];

		for (let i = 0; i < this.props.filterConfig.gender.length; i++) {
			genders.push(this.getGenderFilterButton(this.props.filterConfig.gender[i], genders.length));
		}

		return (
			<div key={generateKey('searchresults-gender-filter', idx)} className="searchresults_filter-block">
				<span className="searchresults_filter-gender-title"> {Translations.get('CollectionSearchResultsDarsteller')}: </span>
				{genders}
			</div>
		);
	}

	getOnlineFilter(idx) {
		return <div key={generateKey('searchresults-online-filter', idx)} className="searchresults_filter-block">
			<input type="checkbox"
			       id="searchresults_filter-online"
			       className={"form__hidden-input"}
			       checked={!!this.state.filter.online}
			       onChange={this.onChangeOnline}
			       value="true"
			/>
			<label className="form__label" htmlFor="searchresults_filter-online">
				<span className="form__checkbox__checkbox" />
				{Translations.get('MessengerShowOnlyOnline')}
			</label>
		</div>;
	}

	getFreeFilter(idx) {
		return <div key={generateKey('searchresults-free-filter', idx)} className="searchresults_filter-block">
			<input type="checkbox"
			       id="searchresults_filter-free"
                   className={"form__hidden-input"}
			       checked={!!this.state.filter.free}
			       onChange={this.onChangeFree}
			       value="true"
			/>
			<label className="form__label" htmlFor="searchresults_filter-free">
				<span className="form__checkbox__checkbox" />
				{Translations.get('FilterOnlyFree')}
			</label>
		</div>;
	}

	getFsk18Filter(idx) {
		return <div key={generateKey('searchresults-fsk18-filter', idx)} className="searchresults_filter-block">
			<input type="checkbox"
			       id="searchresults_filter-fsk18"
                   className={"form__hidden-input"}
			       checked={!!this.state.filter.fsk18}
			       onChange={this.onChangeFsk18}
			       value="true"
			/>
			<label className="form__label" htmlFor="searchresults_filter-fsk18">
				<span className="form__checkbox__checkbox" />
				{Translations.get('Over18')}
			</label>
		</div>;
	}

	getSorting(idx) {
		const sortings = [];
		for (let i = 0; i < this.props.filterConfig.sortings.length; i++) {
			sortings.push({key: this.props.filterConfig.sortings[i], label: Translations.get('order.' + this.props.filterConfig.sortings[i])});
		}

		return <div key={generateKey('searchresults-sorting', idx)} className="searchresults_filter-block">

			<span className="searchresults_filter-sorting-title">{Translations.get('SortBy')}:</span>
			<span className="searchresults_filter-sorting-wrapper">
				<TransformingSelect name="sort"
				                    onChange={this.onChangeSorting}
				                    isDisabled={false}
				                    id="sort"
				                    className="searchresults_filter-sorting-select"
				                    options={sortings}
				                    isMobile={false}
				                    selected={this.state.filter.sorting}
				/>
			</span>
		</div>;
	}

	render() {
		const content = [];

		if (this.props.filterConfig.gender && this.props.filterConfig.gender.length > 1) {
			content.push(this.getGenderFilter(content.length));
		}
		if (this.props.filterConfig.online) {
			content.push(this.getOnlineFilter(content.length));
		}
		if (this.props.filterConfig.free) {
			content.push(this.getFreeFilter(content.length));
		}
		if (this.props.filterConfig.fsk18) {
			content.push(this.getFsk18Filter(content.length));
		}
		if (this.props.filterConfig.sortings && this.props.filterConfig.sortings.length > 1) {
			content.push(this.getSorting(content.length));
		}

		return <div className="searchresults_filter">{content}</div>;
	}
}

SearchResultsFilter.propTypes = {
	filterConfig:   PropTypes.shape({
		gender:  PropTypes.arrayOf(PropTypes.string),
		online:   PropTypes.bool,
		free:     PropTypes.bool,
		fsk18:    PropTypes.bool,
		sortings: PropTypes.arrayOf(PropTypes.string),

	}),
	filter:         PropTypes.shape({
		gender:  PropTypes.arrayOf(PropTypes.string),
		online:  PropTypes.bool,
		free:    PropTypes.bool,
		fsk18:   PropTypes.bool,
		sorting: PropTypes.string,
	}),
	onFilterChange: PropTypes.func,
};

SearchResultsFilter.defaultProps = {};

export default SearchResultsFilter;
